export default __webpack_public_path__ + "837a01cd746151e17177045e38242c84.glb";